import styled from 'styled-components';
import { GridProps, LayoutProps, SpaceProps, grid, layout, space } from 'styled-system';

type BoxProps = {
  row?: boolean;
  column?: boolean;
  gap?: string;
};

export const Box = styled.div<LayoutProps & SpaceProps & GridProps & BoxProps>`
  ${({ row = false }): string | false =>
    row &&
    `
    display: grid;
    grid-auto-flow: row;
  `}
  ${({ column = false }): string | false =>
    column &&
    `
    display: grid;
    grid-auto-flow: column;
  `}

  ${({ gap = false }): string | false => gap && `grid-gap: ${gap}`}


  ${layout};
  ${space};
  ${grid};
`;
